import React from 'react';
import proptypes from 'prop-types';
import { Lists } from '@thd-olt-component-react/user-lists';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

const { string } = proptypes;

export const UserListsCard = ({ componentId = '' }) => (
  <ErrorBoundary name="dashboard-snapshot-lists">
    <Lists componentId={componentId} isDashboardSnapshot fillHeight />
  </ErrorBoundary>
);

UserListsCard.propTypes = {
  componentId: string,
};

UserListsCard.displayName = 'UserListsCard';
UserListsCard.dataModel = Lists.dataModel;
